const translations = {
    en: {
        appTitle: "FormForge",
        login: "Sign In",
        register: "Sign Up",
        logout: "Sign Out",
        admin: "Admin",
        userManagement: "User Management",
        publicTemplates: "Public Templates",
        templates: "Templates",
        forms: "Forms",
        createTemplate: "Create Template",
        editTemplate: "Edit Template",
        welcome: "Welcome to FormForge!",
        latestTemplates: "Latest Templates",
        top5Templates: "Top 5 Templates",
        tags: "Tags",
        viewDetails: "View Details",
        comments: "Comments",
        questions: "Questions",
        yourTemplates: "Your Templates",
        noTemplates: "No templates available. Create one to get started!",
        title: "Title",
        topic: "Topic",
        accessType: "Access Type",
        description: "Description",
        image: "Image",
        noAccount: "Don't have an account?",
        yesAccount: "Already have an account?",
        home: "Home",
        dashboard: "Dashboard"
    },
    uz: {
        appTitle: "FormForge",
        login: "Kirish",
        register: "Ro'yxatdan o'tish",
        logout: "Chiqish",
        admin: "Admin",
        userManagement: "Foydalanuvchilarni boshqarish",
        publicTemplates: "Ochiq Shablonlar",
        templates: "Shablonlar",
        forms: "Formalar",
        createTemplate: "Shablon yaratish",
        editTemplate: "Shablonni tahrirlash",
        welcome: "FormForge ga xush kelibsiz!",
        latestTemplates: "Eng so'nggi Shablonlar",
        top5Templates: "Eng mashhur 5 ta Shablonlar",
        tags: "Teglar",
        viewDetails: "Tafsilotlarni ko'rish",
        comments: "Izohlar",
        questions: "Savollar",
        yourTemplates: "Shablonlaringiz",
        noTemplates: "Hech qanday shablon mavjud emas. Boshlash uchun bitta yarating!",
        title: "Sarlavha",
        topic: "Mavzu",
        accessType: "Kirish turi",
        description: "Tavsif",
        image: "Rasm",
        noAccount: "Akkauntingiz yo'qmi?",
        yesAccount: "Akkountingiz bormi?",
        home: "Bosh sahifa",
        dashboard: "Dashboard"
    }
};

export default translations;